export const environment = {
  production: false,
  apiUrl: 'https://andreadb.dev.flows.emailchef.com/index.php',
  emailchefEndpointUrl: "https://andreadb.dev.emailchef.com",
  emailchefAuthkey: null,
  showDebugInfo: true,
  canvasRightClick: false,
  type: 'dev',
  hotjar: null
};
